import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cigna-resources-modal',
  templateUrl: './resources-modal.component.html',
  styleUrls: ['./resources-modal.component.scss'],
})
export class ResourcesModalComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  titleText = '';

  @ViewChild('modalContainer', { static: false }) modalContainer: TemplateRef<
    any
  >;

  ngOnInit() {
    const modalLinks = document.querySelectorAll('a.cg-modal-link');

    modalLinks.forEach((t) => {
      t.addEventListener('click', this.openModal);
    });
  }

  openModal = (event: MouseEvent) => {
    const currentTarget = event.currentTarget as HTMLAnchorElement;

    event.preventDefault();

    const href = currentTarget.href;
    const modalHeaderText = currentTarget.getAttribute('data-modal-header');
    const bodyHtml = document.getElementById(href.split('#')[1]);

    this.dialog.open(this.modalContainer, {
      autoFocus: false,
      width: '750px',
      data: {
        header: modalHeaderText,
        body: bodyHtml?.innerHTML,
      },
    });
  };

  closeDialog() {
    this.dialog.closeAll();
  }
}
